import React, { useState, useEffect } from 'react'
import { Button, Grid } from '@material-ui/core'
import MaterialTable from 'material-table'
import AddIcon from '@material-ui/icons/Add'
import { ModalLinkedIn } from '../../Modals/ModalSec3/ModalLinkedIn'
import { getProviderList } from '../../../../../services/AsistenciaTecnica/get'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import swal from 'sweetalert'
import { deleteProviderList } from '../../../../../services/AsistenciaTecnica/delete'

export const TableLinkedIn = ({ IdTechnicalAssistanceAnswer, formik }) => {
  const [open, setOpen] = useState(false)
  const [data, setData] = useState([])
  const [body, setBody] = useState({})

  const getProvider = async () => {
    try {
      const response = await getProviderList(IdTechnicalAssistanceAnswer)
      if (response.Success) {
        if (response.Data.length >= 1) {
          formik('validateTable34', true)
        } else {
          formik('validateTable34', false)
        }
        setData(response.Data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleDelete = async (id) => {
    try {
      const response = await deleteProviderList(id)

      if (response.Success) {
        swal({
          title: '¡Registro eliminado exitosamente!',
          icon: 'success',
        })
        getProvider()
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getProvider()
  }, [])

  const columns = [
    {
      title: 'Nombre',
      field: 'NameProvider',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Perfil',
      field: 'ProviderLinkedIn',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      render: (expense) => (
        <a
          href={expense.ProviderLinkedIn}
          target="_blank"
          rel="noopener noreferrer"
        >
          {expense.ProviderLinkedIn}
        </a>
      ),
    },
  ]

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={data}
            onSelectionChange={(selectedRows) => console.log(selectedRows)}
            actions={[
              {
                icon: () => (
                  <Button
                    variant="contained"
                    color="success"
                    style={{ backgroundColor: '#27C27D', color: '#FFFFFF' }}
                    startIcon={<AddIcon style={{ color: 'white' }} />}
                  >
                    Agregar registro
                  </Button>
                ),
                tooltip: 'Agregar',
                position: 'toolbar',
                onClick: () => {
                  setOpen(true)
                },
              },
              {
                icon: () => <EditIcon style={{ color: '#0d53ad' }} />,
                tooltip: 'Editar',
                onClick: (event, rowData) => {
                  setOpen(true)
                  setBody(rowData)
                },
              },
              {
                icon: () => <DeleteIcon style={{ color: 'red' }} />,
                tooltip: 'Eliminar registro',
                onClick: (event, rowData) => {
                  swal({
                    title: '¿Está seguro de eliminar el registro?',
                    icon: 'warning',
                    buttons: ['No', 'Si'],
                    dangerMode: true,
                  }).then(function (isConfirm) {
                    if (isConfirm) {
                      handleDelete(rowData.IdProviderList)
                    }
                  })
                },
              },
            ]}
            options={{
              sorting: true,
              search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              filtering: true,
              paging: false,
              pageSizeOptions: [2, 5, 10, 20],
              pageSize: 5,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'bottom',

              exportFileName: 'TableData',
              addRowPosition: 'first',
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              toolbarButtonAlignment: 'left',
              selectionProps: (rowData) => ({
                disabled: rowData.age == null,
                // color:"primary"
              }),

              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            title=" "
          />
        </Grid>
        <ModalLinkedIn
          open={open}
          setOpen={setOpen}
          body={body}
          setBody={setBody}
          getProvider={getProvider}
          IdTechnicalAssistanceAnswer={IdTechnicalAssistanceAnswer}
        />
      </Grid>
    </>
  )
}
